export default {
  bindings: {
    'minimumGuests': '<',
    'maximumGuests': '<',
    'gender': '<',
    'staff': '=',
    'showGuestLabels': '<'
  },
  controller: 'guestAdditionController',
  template: require('../views/guest.addition.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/guest/components/guest.addition.component.js